import { Row } from "react-bootstrap";
import EquipmentList from "./EquipmentList";
import EquipmentDetail from "./EquipmentDetail";
import ComponentInformation from "./ComponentInformation";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { REMOVE_ALL_PERSISTED_DATA, SET_EQUIPMENT_UNIT_CLASSES_LIST } from "../../../store/actions";
import EquipmentBreadcrumb from "./EquipmentBreadcrumb";
import { useQuery } from "react-query";
import { fetchAllEquipmentUnitClasses } from "../../../api";
import { checkForAPISuccess, showErrorToast } from "../../../Common/commonFunctions";

const EquipmentPage = () => {

    const dispatch = useDispatch();
    const [utils, setUtils] = useState({ equipmentId: "" });
    const breakPoints = { xs: 12, sm: 12, md: 4, lg: 4, xl: 4 };
    const useQueryConfiguration = {
        enabled: false,
        retry: false,
        retryOnMount: false,
        refetchOnMount: false,
        refetchOnWindowFocus: false
    };

    const fetchEquipmentUnitClasses = async () => {
        const response = await fetchAllEquipmentUnitClasses();
        return response?.data
    }

    const fetchEquipmentUnitClassesQuery = useQuery('fetchEquipmentUnitClasses', fetchEquipmentUnitClasses, { ...useQueryConfiguration });

    useEffect(() => {
        dispatch({ type: REMOVE_ALL_PERSISTED_DATA });
        fetchEquipmentUnitClassesQuery.refetch();
    }, []);

    useEffect(() => {
        if(fetchEquipmentUnitClassesQuery.isFetched) {
            if(fetchEquipmentUnitClassesQuery.isSuccess && checkForAPISuccess(fetchEquipmentUnitClassesQuery?.data?.statusCode)) {
                dispatch({ type: SET_EQUIPMENT_UNIT_CLASSES_LIST, payload: fetchEquipmentUnitClassesQuery.data?.data });
            }
            else {
                showErrorToast("Failed to fetch equipment unit classes");
            }
        }
    }, [fetchEquipmentUnitClassesQuery.isFetched])

    const reloadPage = (profileId) => window.location.pathname = `${window.configs.dashboard_base_path}/profile/${profileId}`;

    return (
        <>
            <EquipmentBreadcrumb reloadPage={(profileId) => reloadPage(profileId)} />

            <Row className="mt-1 p-0">

                <EquipmentList
                    breakPoints={breakPoints}
                    setCurrentEquipmentId={(id) => setUtils({ ...utils, equipmentId: id })}
                />

                <EquipmentDetail
                    {...utils}
                    breakPoints={breakPoints}
                />

                <ComponentInformation
                    equipmentId={utils.equipmentId}
                    breakPoints={breakPoints}
                />

            </Row>
        </>
    );
}

export default EquipmentPage;